import {configureStore} from '@reduxjs/toolkit';
import {useMemo} from "react";
import {api} from "@/redux/api";


export function initializeStore(preloadedState) {
    return configureStore({
        reducer: {
            [api.reducerPath]: api.reducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(api.middleware),
        preloadedState,
    });
}

export function useStore(initialState) {
    return useMemo(() => initializeStore(initialState), [initialState]);
}